module.exports = __webpack_public_path__ + "img/ETH-alt.32708c79.svg";